import { type PropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const kanbanBoardV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate kanban element to v2',
  run: (props: PropsOf<'kanbanBoard'>): void => {
    if (props.style?.background?.radius && !props.style.card?.radius) {
      props.style.card ??= {} as any;
      props.style.card.radius = props.style?.background?.radius;
    }
  },
};
